import script from "./InputSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./InputSecondary.vue?vue&type=script&setup=true&lang=js"

import "./InputSecondary.vue?vue&type=style&index=0&id=4d69f1d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d69f1d4"]])

export default __exports__